import { createSlice } from '@reduxjs/toolkit';
import { fetchChartData } from '../thunks/chartThunks';

const defaultChartState = (overrides = {}) => ({
  selectedX: '',
  selectedY: '',
  chartType: 'bar',
  aggregatedData: null,
  data: null,
  chartLoading: false,
  combinedList: [],
  exportFileResponseMsg: null,
  ...overrides,
});

const initialState = {
  charts: {
  },
};

const chartSlice = createSlice({
  name: 'chart',
  initialState,
  reducers: {
    createChart(state, action) {
      const { chartId, initial = {} } = action.payload;
      if (!state.charts[chartId]) {
        state.charts[chartId] = defaultChartState(initial);
      }
    },
    removeChart(state, action) {
      const { chartId } = action.payload;
      delete state.charts[chartId];
    },
    setChartField(state, action) {
      const { chartId, field, value } = action.payload;
      if (!state.charts[chartId]) return;
      state.charts[chartId][field] = value;
    },
    setSelectedX(state, action) {
      const { chartId, value } = action.payload;
      if (!state.charts[chartId]) return;
      state.charts[chartId].selectedX = value;
    },
    setSelectedY(state, action) {
      const { chartId, value } = action.payload;
      if (!state.charts[chartId]) return;
      state.charts[chartId].selectedY = value;
    },
    setChartType(state, action) {
      const { chartId, value } = action.payload;
      if (!state.charts[chartId]) return;
      state.charts[chartId].chartType = value;
    },
    setAggregatedData(state, action) {
      const { chartId, value } = action.payload;
      if (!state.charts[chartId]) return;
      state.charts[chartId].aggregatedData = value;
    },
    setData(state, action) {
      const { chartId, value } = action.payload;
      if (!state.charts[chartId]) return;
      state.charts[chartId].data = value;
    },
    setChartLoading(state, action) {
      const { chartId, value } = action.payload;
      if (!state.charts[chartId]) return;
      state.charts[chartId].chartLoading = value;
    },
    setCombinedList(state, action) {
      const { chartId, value } = action.payload;
      if (!state.charts[chartId]) return;
      state.charts[chartId].combinedList = value;
    },
    setExportFileResponseMsg(state, action) {
      const { chartId, value } = action.payload;
      if (!state.charts[chartId]) return;
      state.charts[chartId].exportFileResponseMsg = value;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchChartData.pending, (state, action) => {
        const chartId = action.meta.arg.chartId;
        if (!state.charts[chartId]) return;
        state.charts[chartId].chartLoading = true;
        state.charts[chartId].exportFileResponseMsg = null;
      })
      .addCase(fetchChartData.fulfilled, (state, action) => {
        const chartId = action.meta.arg.chartId;
        if (!state.charts[chartId]) return;
        state.charts[chartId].aggregatedData = action.payload.aggregatedData;
        state.charts[chartId].data = action.payload.data;
        state.charts[chartId].chartLoading = false;
      })
      .addCase(fetchChartData.rejected, (state, action) => {
        const chartId = action.meta.arg.chartId;
        if (!state.charts[chartId]) return;
        state.charts[chartId].chartLoading = false;
        state.charts[chartId].exportFileResponseMsg = action.payload;
      });
  },
});

export const {
  createChart,
  removeChart,
  setChartField,
  setSelectedX,
  setSelectedY,
  setChartType,
  setAggregatedData,
  setData,
  setChartLoading,
  setCombinedList,
  setExportFileResponseMsg,
} = chartSlice.actions;

export default chartSlice.reducer;
